module.exports = "/images/search.svg?5c04d0c591ab2bf9d58319ab19899802";